import { useContext } from "react";
import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";
import { ActionTypeEnum } from "@attelas/shared";

export const useCompleteMention = (mentionId: string, mentionType: string) => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { trigger, isMutating, error } = useSWRMutation(
    mentionType === ActionTypeEnum.Chasable
      ? `${environment.apiUrl}/api/mentions/${mentionId}/complete`
      : `${environment.apiUrl}/api/emails/actions/mentions/${mentionId}/complete`,
    (url: string) => fetcher<{ result: string }>(url, { method: "POST" }),
    {
      onError: () => {
        showToast("Failed to mark mention as read, please try again later", "error");
      },
    }
  );

  return {
    complete: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
